module.exports = __webpack_public_path__ + "d57c8bee664f315e2b89181d706d4af8.png";